import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  PermissionListReq,
  PermissionListRes,
  CreatePermissionReq,
  ActionPermissionRes,
  UpdatePermissionReq,
  DeletePermissionReq,
  PermissionDetailReq,
  PermissionData,
  PermissionDetailRes,
} from './types'

export const getPermissionListAction = createAsyncAction(
  'ROLE/GET_ROLE_LIST_REQ',
  'ROLE/GET_ROLE_LIST_SUCCESS',
  'ROLE/GET_ROLE_LIST_FAILURE',
)<PermissionListReq, PermissionListRes, Error>()

export const getPermissionDetailAction = createAsyncAction(
  'ROLE/GET_ROLE_DETAIL_REQ',
  'ROLE/GET_ROLE_DETAIL_SUCCESS',
  'ROLE/GET_ROLE_DETAIL_FAILURE',
)<PermissionDetailReq, PermissionDetailRes, Error>()

export const createPermissionAction = createAsyncAction(
  'ROLE/CREATE_ROLE_REQ',
  'ROLE/CREATE_ROLE_SUCCESS',
  'ROLE/CREATE_ROLE_FAILURE',
)<CreatePermissionReq, ActionPermissionRes, Error>()

export const updatePermissionAction = createAsyncAction(
  'ROLE/UPDATE_ROLE_REQ',
  'ROLE/UPDATE_ROLE_SUCCESS',
  'ROLE/UPDATE_ROLE_FAILURE',
)<UpdatePermissionReq, ActionPermissionRes, Error>()

export const deletePermissionAction = createAsyncAction(
  'ROLE/DELETE_ROLE_REQ',
  'ROLE/DELETE_ROLE_SUCCESS',
  'ROLE/DELETE_ROLE_FAILURE',
)<DeletePermissionReq, ActionPermissionRes, Error>()

export const getAllPermissionListAction = createAsyncAction(
  'ROLE/GET_ALL_ROLE_LIST_REQ',
  'ROLE/GET_ALL_ROLE_LIST_SUCCESS',
  'ROLE/GET_ALL_ROLE_LIST_FAILURE',
)<PermissionListReq, PermissionListRes, Error>()

export const clearEventAction = createStandardAction('ROLE/CLEAR_EVENT')<void>()
